import React from 'react'
import { CardSection, Heading } from './CardSection'
import { Item, UsageItemList } from './Item'

export type ItemsForSubmittionProps = {
  items: Item[]
}

export const ItemsForSubmittion = ({ items }: ItemsForSubmittionProps) => {
  return (
    <CardSection>
      <Heading as="h3">施設に提出するもの</Heading>
      <UsageItemList items={items} />
    </CardSection>
  )
}
